import React, { useEffect, useState } from 'react'
import styles from './PlayerAccountView.module.css'
import { useTranslation } from 'react-i18next'
import { PlayerAccountGamesOverview } from './PlayerAccountGamesOverview'
import { useGameData } from '../../contexts/PlayerAccountGamesContext'
import { JoinGame } from './components/JoinGame'
import { PlayerTopbar } from '../../composites/topbar/PlayerTopbar'
import { useUser } from '../../contexts/userContext'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../routes'
import { LoaderBlock } from '../../common/components/loaders/LoaderBlock/LoaderBlock'

export const PlayerAccountView: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user, loginState } = useUser()
  const { loading, pageData } = useGameData()
  const [waitCounter, setWaitCounter] = useState(0)
  const name = user?.playerName || user?.name || user?.chatName || ''
  const emptyContent = {
    title: t('player_account_view.empty_dashboard.title', 'You have no games yet'),
    subtitle: t(
      'player_account_view.empty_dashboard.subtitle',
      'Add a game with PIN code or wait for an invite from your instructor!',
    ),
  }

  useEffect(() => {
    if (user == null) {
      if (loginState === 'PENDING') {
        if (waitCounter > 6) {
          navigate(routes.login)
        } else {
          setTimeout(() => {
            setWaitCounter(waitCounter + 1)
          }, 500)
        }
      } else if (loginState === 'LOGGED_OUT') {
        navigate(routes.login)
      }
    }
  }, [loginState, navigate, user, waitCounter])

  if (loginState === 'LOGGED_OUT' || loginState === 'PENDING' || loading) {
    return (
      <div className={styles.loaderContainer}>
        <LoaderBlock />
      </div>
    )
  }

  return (
    <div className={styles.pageContainer}>
      <PlayerTopbar />
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h1>{t('player_account_view.page_title', { defaultValue: 'Hi %{name}!', name: name })}</h1>
        </div>
        <PlayerAccountGamesOverview emptyContent={emptyContent} pageData={pageData} />
        <JoinGame />
      </div>
    </div>
  )
}
